import Image from "next/image"
import Link from "next/link"
import { usePropsObject } from "@/lib/contexts/appContext"
import Block from "@/components/wrappers/block"
import styles from "./textImageBlock.module.css"
import classNames from "classnames"
import { themePlateColor, themeTextColor } from "@/lib/helpers/utils"

export default function TextImageBlock({
  block,
  children,
  className,
  hasPlate = true,
  hovered = false,
  image,
  imageSize = null,
  layout,
  link = null,
  padding = true,
  plateColor,
  width = "full"
}) {
  const { theme } = usePropsObject()

  if (!plateColor) {
    plateColor = theme?.plateColor
  }

  let textColor = themeTextColor(theme?.txtColor, "text-black-100")
  if (plateColor === "lime") {
    textColor = "text-black-100"
  }

  if (plateColor === "white" && textColor === "text-white") {
    textColor = "text-black-100"
  }

  return (
    <Block
      block={block}
      width="full"
      className={classNames(styles.wrapper, className, {
        "no-offset": !padding,
        "is-narrow": width === "narrow",
        "layout-right":
          layout === "right" && !["medium", "small"].includes(imageSize)
      })}>
      <Container {...{ link, padding, hasPlate, plateColor, textColor }}>
        <div
          className={classNames("content-grid", {
            "no-grid": width === "narrow",
            "no-image": !image?.url,
            "image-medium": !hasPlate && imageSize === "medium",
            "image-small": !hasPlate && imageSize === "small"
          })}>
          {image?.url && (
            <div
              className={classNames("image-wrapper", {
                "no-padding": !padding
              })}>
              <figure
                className={classNames(hovered ? "image-hover-effect" : "")}>
                {image?.url && (
                  <Image
                    className="image"
                    src={image.url}
                    width={image.width}
                    height={image.height}
                    sizes={image.sizes}
                    alt={image.alt}
                  />
                )}
                {image?.credit && (
                  <div className={classNames("credit", textColor)}>
                    Foto av: {image.credit}
                  </div>
                )}
              </figure>
            </div>
          )}
          <div
            className={classNames("content-wrapper", {
              "need-padding": !padding,
              "is-transparent": plateColor === "transparent"
            })}>
            {children}
          </div>
        </div>
      </Container>
    </Block>
  )
}

const Container = ({
  link,
  children,
  padding,
  hasPlate,
  plateColor,
  textColor
}) => {
  const classes = [
    "inner-wrapper",
    {
      "no-padding": !padding
    },
    hasPlate ? themePlateColor(plateColor) : "transparent",
    textColor
  ]

  if (!link?.url) {
    return <div className={classNames(classes)}>{children}</div>
  }

  return (
    <Link
      className={classNames(classes)}
      href={link.url}
      prefetch={false}
      target={link.target}
      rel={link.nofollow ? "nofollow" : undefined}>
      {children}
    </Link>
  )
}
